// ----------------------------------------------------------------------

export const role = [
  'STEM',
  'Refacción',
  'Argumentación',
  'Historia',
  'Pensamiento Crítico',
  'Resolución de Problemas',
  'Literatura',
  'Matemáticas Avanzadas',
  'Ciencias de la Vida',
  'Investigación',
  'Creatividad',
  'Conocimiento del Idioma Extranjero',
  'Arte',
  'Estudios Sociales',
  'Ciencias Físicas',
  'Educación Física',
  'Gestión de Proyectos',
  'Capacidad de Adaptación',
  'Trabajo en Equipo',
  'Habilidades de Presentación',
  'Organización',
  'Ciencias Ambientales',
  'Programación',
  'Música',
  'Psicología',
  'Habilidades Interpersonales',
  'Estadística',
  'Economía',
  'Química',
  'Habilidades de Liderazgo',
  'Ética y Ciudadanía',
  'Biología',
  'Geografía',
  'Filosofía',
  'Diseño Gráfico',
  'Teatro',
];

